<div *ngIf="!isLink" class="{{className}}">{{text}}</div>

<a *ngIf="isLink" routerLink="{{link}}"><div class="{{className}}"></div>{{text}}</a>